import { render, staticRenderFns } from "./ListagemFollowupConvenio.vue?vue&type=template&id=1a68cb80"
import script from "./ListagemFollowupConvenio.vue?vue&type=script&lang=js"
export * from "./ListagemFollowupConvenio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports